module.exports = __webpack_public_path__ + "img/wear-tight.c0d74fc6.svg";